define('utils/AnimateProcessor', [],function () {
    'use strict';

    var animationFrame = (function () {
        return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRquestAnimationFrame ||
            function (fn) {
                return window.setTimeout(function () {
                    fn(Date.now())
                }, 20)
            }
    })()

    var animationFrameCancel = (function () {
        return window.cancelAnimationFrame ||
            window.webkitCancelAnimationFrame ||
            window.mozCancelAnimationFrame ||
            window.oCancelAnimationFrame ||
            window.msCancelAnimationFrame ||
            clearTimeout
    })();

    function AnimateProcessor(duration) {
        this.frameId = null
        this.duration = duration || 1000
    }

    AnimateProcessor.prototype.excuteAnimaFrame = function (cb, success) {
        var start
        var timeInterval = 0
        var percentage
        var that = this

        var startAnimate = function (timestamp) {
            if (!start) {
                start = timestamp
            }

            timeInterval += timestamp - start
            percentage = timeInterval / that.duration
            percentage = percentage > 1 ? 1 : percentage

            /**@return {Boolean}  true 表示动画帧继续 false 代表动画执行结束*/
            if (cb.call(that, percentage)) {
                that.frameId = animationFrame(startAnimate)
                start = timestamp
            } else {
                typeof success === 'function' && success.call(that)
                animationFrameCancel(that.frameId)
            }
        }

        that.frameId = animationFrame(startAnimate)
    }

    AnimateProcessor.prototype.getIncByTimeFn = function (setting, time) {
        var pattern = 0;
        if (setting == 'ease-in-out') pattern = time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1;
        if (setting == 'ease-in') pattern = time * time;
        if (setting == 'ease-out') pattern = time * (2 - time);
        return pattern || time;
    }

    AnimateProcessor.prototype.cancelAnimate = function () {
        this.frameId !== null && animationFrameCancel(this.frameId)
    } 


    return AnimateProcessor
}); 
